import actionTypes from 'SRC/modules/redux/actionTypes'
import { CookiesHelper } from 'src/core/cookiesHelper/CookiesHelper'
import { AdsDetailApi } from 'SRC/modules/ads/detail/api'
import { getCurrentLocale } from 'SRC/modules/common/functions'
import { setCurrentAd } from 'SRC/modules/ads/detail/actions'

const _updateAdById = (id, fields) => ({
  type: actionTypes.UPDATE_AD_BY_ID,
  payload: { id, fields }
})

export const updateAdById = (id, fields) => {
  return async (dispatch, getState) => {
    dispatch(_updateAdById(id, fields))

    const state = getState()

    const adsDetail = state?.ads?.detail?.currentAd

    if (adsDetail) {
      const adDetailApi = new AdsDetailApi()

      const cookies = new CookiesHelper()
      const userId = cookies.get('userId') || null
      const token = cookies.get('token') || null

      const locale = getCurrentLocale()

      const { ad, error } = await adDetailApi.getAd({ seo: adsDetail.seo, userId, token, locale })

      if (!error && ad) dispatch(setCurrentAd(ad))
    }
  }
}
